import React, { useEffect, useState } from 'react'
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate'
import { ColumnPendingApproval, PendingApprovalData } from '../../../types/TablesTypes/PendingApprovals'
import showToast from '../../../components/CustomToast/toastHelper'
import client from '../../../api/client'
import { FaEllipsisH } from 'react-icons/fa'
import { useCurrency } from '../../../contexts/CurrencyContext'
const PendingApprovals = () => {
  // const headings =["Amount", "Narration", "Recipient", "Date"]
  const { currency } = useCurrency()
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    currency: currency
  })

  const [pendingApprovals, setPendingApprovals] = useState<any>()
  const [tableRow, setTableRow] = useState<any[]>()
  const [loading, setLoading] = useState<boolean>(true);
  const [isExport, setIsExport] = useState<boolean>(false)
  const [isExportReady, setIsExportReady] = useState<boolean>(false);
  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);

  const clickExport = async () => {
    setIsExport(true);
    setIsExportLoading(true)
    await fetchPending();

    if (pendingApprovals && pendingApprovals.data?.length > 0) {
      setIsExportReady(true);
    }

    setIsExportLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      await fetchPending();
      setLoading(false)
    };
    fetchData();
  }, [filters, currency])
  const fetchPending = async () => {
    try {
      const apiUrl = '/subsidiary/payout/pending/approval';
      const params = new URLSearchParams(filters).toString();
      const response = await client.get(`${apiUrl}?${params}`);

      setPendingApprovals(response.data);
      const message = response?.data?.message;

    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        const message = err?.response?.data?.message;
        console.error('error getting data', err);
        showToast(message, "error");
      }
    }
  };

  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      currency: currency,
    }));
  }, [currency]);

  const approveAllPayouts = async () => {
    return null
  };

  const dataTransaction = () => {
    const tempArr: PendingApprovalData[] = [];
    pendingApprovals?.data
      ?.slice(0)
      .reverse()
      .forEach((transaction: any, index: number) => {
        tempArr.push({
          amount: transaction.amount,
          narration: transaction.narration,
          recipient: transaction.recipient,
          date: transaction.date,
          // date: moment(transaction?.date_created).format('DD MMM YYYY'),
          action: <FaEllipsisH />,
        });
      });
    return tempArr;
  };

  useEffect(() => {
    setTableRow(dataTransaction());
  }, [pendingApprovals?.data]);
  return (
    <div>
      <DashboardPagesTemplate
        apiUrl='/subsidiary/payout/pending/approval'
        dataToExport={pendingApprovals?.data}
        title='Pending Approval'
        onFilterChange={setFilters}
        headings={ColumnPendingApproval}
        exportButtonExists={true}
        ctaButtonExists={true}
        buttonLabel='Approve all'
        data={tableRow ? tableRow : []}
        buttonIcon=''
        showSearch={false}
        filters={filters}
        dropdownItems={[]}
        datepickerExists={false}
        emptyMessage={`You do not have any pending approvals in ${currency}`}
        onCtaButtonClick={approveAllPayouts}
        loading={loading}
        clickExportButton={clickExport}
        exportButtonLoading={isExportLoading}
        exportButtonClicked={isExport}
      />
    </div>
  )
}

export default PendingApprovals
